<div class="ui-uploader form-control"
	 ondragover="this.className='ui-uploader form-control ui-uploader-drag-over';return false;"
	 ondragleave="this.className='ui-uploader form-control ';return false;"
	 ondrop="this.className='ui-uploader form-control ';return false;"
	 (drop)="onDrop($event)"
>
	<button class="btn btn-danger btn-sm" [hidden]="!filesWithErrorsCount" (click)="toggleList()">{{filesWithErrorsCount}}</button>

	<span class="ui-uploader-placeholder">{{text}}</span>
	<div class="ui-uploader-list panel panel-default" [hidden]="!listVisible">
		<div class="panel-body">
			<ul class="list-group">
				<li class="list-group-item" *ngFor="let f of files;let i=index">

					<span class="label text">{{f.name}}</span>
					&nbsp;
					<span (click)="download(f)" class="btn btn-primary btn-sm">
						download
					</span>

					<span *ngIf="!readOnly" (click)="delete(f,i)" class="btn btn-danger btn-sm">
						remove
					</span>
					&nbsp;
				</li>
			</ul>
		</div>
	</div>
</div>
